import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Notice, NoticeSteps } from '../PurchaseV2.styles';

function DocumentsResubmissionWarning({ quoteStatus }) {
  if (quoteStatus !== 2) return null;

  return (
    <Notice $tone="warning" className="mb-3">
      <FontAwesomeIcon icon={faTriangleExclamation} />
      <div>
        <p>
          <strong>Attenzione: ci sono problemi con uno o più documenti.</strong>
        </p>
        <p>
          Uno o più documenti caricati sono stati contrassegnati come &quot;Non Validi&quot; dall&apos;ufficio.
          Per inviarli nuovamente segui questi passaggi:
        </p>
        <NoticeSteps>
          <li>Rimuovi il documento contrassegnato come &quot;Non Valido&quot;.</li>
          <li>Carica il documento corretto al suo posto.</li>
          <li>
            Clicca nuovamente il pulsante
            {' '}
            <b>&quot;Invia Documenti&quot;</b>
            {' '}
            per inviarli all&apos;ufficio.
          </li>
        </NoticeSteps>
      </div>
    </Notice>
  );
}

export default DocumentsResubmissionWarning;
